/*
Copyright (c) 2021
*/

import actions from '../../actions';


// reducer with initial state
const initialState = {
  lastUpdated:null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddNewUserGenPoolAction.REQUEST_ADDNEWUSERGENPOOL:
      return {
        ...state,
    };
    case actions.AddNewUserGenPoolAction.ADDNEWUSERGENPOOL_RECEIVED:
      return {
        ...state,
        Response: action.payload,
        statusCode: action.payload?.Status?.StatusCode,
        statusDesc: action.payload?.Status?.StatusDesc,
        lastUpdated: Date.now()
      };

    default:
      return state;
  }
};

export default reducer;
